import { render, staticRenderFns } from "./AudienceBody.vue?vue&type=template&id=d00d79c8&"
import script from "./AudienceBody.vue?vue&type=script&lang=js&"
export * from "./AudienceBody.vue?vue&type=script&lang=js&"
import style0 from "./AudienceBody.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports